import axios from 'axios';
import { GetString } from 'fluent-react';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {
  extractFromStringLocationId,
} from '../../graphQL/Utils';
import CountrySelector from '../countrySelector/ConclusionPageCountrySelector';
import { primaryColor1 } from '../Utils';
import ExploreButton from './ExploreButton';
import ExploreCitiesButton from './ExploreCitiesButton';
import {
  FooterContainer as FooterContainerBase,
} from './Grid';

const FooterContainer = styled(FooterContainerBase)`
  display: grid;
  grid-template-columns: minmax(0, 500px) 5rem minmax(0, 500px);
  margin: auto;
`;

const FooterContainerTriColumn = styled(FooterContainerBase)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: auto;
`;

const PanelBase = styled.div`
  margin: 10px 50px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
  background-color: ${primaryColor1};

  @media (max-width: 1200px) {
    margin: 10px 1rem;
  }
`;

const LeftPanel = styled(PanelBase)`
  grid-column: 1;
  position: relative;
`;

const CenterSpace = styled.div`
  grid-column: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  color: ${primaryColor1};
  text-transform: uppercase;
  font-size: 1.2rem;

  &::before,
  &::after {
    content: '';
    height: 35%;
    width: 1px;
    background-color: ${primaryColor1};
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }
`;

const MiddlePanel = styled(PanelBase)`
  grid-column: 2;
`;
const RightPanel = styled(PanelBase)`
  grid-column: 3;
`;

interface Props {
  year: number;
  countryId: string;
  selectCountry: (country: string) => void;
  getFluentString: GetString;
}

const CtaButtons = (props: Props) => {
  const {
    countryId, selectCountry, getFluentString, year,
  } = props;

  const [inMetroverse, setInMetroverse] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    axios({
      url: 'https://metroverse.hks.harvard.edu/graphql',
      method: 'post',
      data: {
        query: `
          query CountryCities {
            classificationCountry(countryId: ${extractFromStringLocationId(countryId)}) {
              countryCity {
                edges {
                  node {
                    name
                  }
                }
              }
            }
          }
          `,
      },
    }).then((result) => {
      if (result.data.data.classificationCountry.countryCity.edges.length) {
        setInMetroverse(true);
      } else {
        setInMetroverse(false);
      }
    }).catch(() => setInMetroverse(false));
  }, [countryId]);

  if (inMetroverse === undefined) {
    return null;
  }

  if (inMetroverse === true) {
      return (
      <FooterContainerTriColumn>
        <LeftPanel>
          <CountrySelector
            selectedCountry={countryId}
            onCountrySelect={selectCountry}
            getFluentString={getFluentString}
          />
        </LeftPanel>
        <MiddlePanel>
          <ExploreButton
            year={year}
            countryId={countryId}
            getFluentString={getFluentString}
          />
        </MiddlePanel>
        <RightPanel>
          <ExploreCitiesButton
            countryId={countryId}
            getFluentString={getFluentString}
          />
        </RightPanel>
      </FooterContainerTriColumn>
    );
  }

  return (
    <FooterContainer>
      <LeftPanel>
        <CountrySelector
          selectedCountry={countryId}
          onCountrySelect={selectCountry}
          getFluentString={getFluentString}
        />
      </LeftPanel>
      <CenterSpace>{getFluentString('conclusion-slide-text-footer-or')}</CenterSpace>
      <RightPanel>
        <ExploreButton
          year={year}
          countryId={countryId}
          getFluentString={getFluentString}
        />
      </RightPanel>
    </FooterContainer>
  );
};

export default CtaButtons;
